// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_I","related":"e_J","breadCrumbs":"e_K","postTags":"e_L","sidebarPostNav":"e_M"};